module.exports = __webpack_public_path__ + "media/images/version_merge/speedo_bnw-e1843855f2abf831feed0a3c9272d156.gif";